// @flow

import React from 'react'

export default ({ label, options, onChange, value }) => {
  const placeHolderStyle = value === '' ? { color: '#d1d1d1' } : {}

  return (
    <div className="search-side__item-select">
      <div className="search-side__select-small">
        <select
          className="reserve_style"
          style={placeHolderStyle}
          onChange={onChange}
        >
          <option value="" selected={'' === value}>
            {label}
          </option>
          {options.map((item, index) => (
            <option
              value={item['id']}
              selected={item['id'] === value}
              key={`search_field_option_${index}`}
            >
              {item['label']}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/SearchSelectField.jsx